<template>
	<nav
		:aria-describedby="`blog-category-filter-title`"
		class="flex flex-col gap-4"
	>
		<div class="flex flex-wrap gap-6 items-center">
			<h2
				:id="`blog-category-filter-title`"
				class="text-functional-size-xs uppercase tracking-wider text-gray-600"
			>
				Categorieën
			</h2>
			<AtomLink
				v-if="currentCategory"
				title="Reset categorie filter"
				url="/blog/"
				class="flex items-center gap-2 text-functional-size-xs uppercase tracking-wider text-gray-800"
			>
				<AtomFontAwesome
					class="size-4"
					icon="fa-arrows-rotate"
				/>
				<span>Reset</span>
			</AtomLink>
		</div>
		<div class="flex flex-wrap gap-4">
			<AtomButton
				v-for="category in categories"
				:key="`blog-category-filter-${category.stem}`"
				size="sm"
				:variant="category.id === currentCategory?.id ? ButtonVariant.Dark : ButtonVariant.DarkBorder"
				:text="category.title"
				:to="{
					title: category.title,
					url: category.path,
				}"
			/>
		</div>
	</nav>
</template>

<script setup lang="ts">
import { ButtonVariant } from '#base/core/enums/ButtonVariantEnum';
import type { BlogCategoryType } from '#base/core/types/BlogCategoryType';

defineProps<{
	categories: BlogCategoryType[];
	currentCategory?: BlogCategoryType;
}>();
</script>
